<template>
  <div
    style="background: #2B0000; overflow-y: scroll; height: 100vh; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;"
  >
  <div style="height: 100vh;">
    <div class="login-cont container">
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column">
          <img
            class="mx-auto mb-4"
            src="https://storage.googleapis.com/spacetech2/shweohhh/logo%20png%20(1).png"
            alt=""
            @click="$router.push('/home')"
            style="height: 6rem"
          />
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
            <div class="card-body px-2 d-flex mx-0 col-12 mx-auto" style="background: #590007;
                border-radius: 7px;">
              <div class="col-12">
                <div class="text-center mb-4">
                  <div class="error text-center py-2" v-if="error">
                    <span class="mx-auto">
                      {{ error }}
                    </span>
                  </div>
                  </div>
                  <form role="form">
                
                  <div class="form-group mb-3 pt-3">
                    <small class="text-dark" style="color: white !important">{{ errors.phone }}</small>
                      <div class="form-group mb-3">
                        <label style="color: white; font-weight: 550; letter-spacing: 0.5px;">{{$t('setting.phone')}}</label>
                        <span class="text-xs" style="color: #EFDB01"> ( ဖုန်းနံပါတ် 09 ပါထည့်ဖြည့်ပါ )</span>
                        <!-- <div
                          class="input-group input-group-merge input-group-alternative bg-transparent"
                        > -->
                          <input
                            class="form-control pl-2 px-4"
                            style="background-color: white; color: black; box-shadow: none; border: none; font-size: 1.2rem;"
                            type="text"
                            v-model="phone"
                          />
                        <!-- </div> -->
                      </div>
                  </div>

                    <div class="text-center mt-4">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: linear-gradient(to bottom, #ffc500 0%, #ff4500 50%, #c71600 100%); color: white; border-radius: .5rem; width: 15rem; box-shadow: none;"
                        @click="!isSignin ? OTPsendToPhone() : ''"
                      >
                        <div v-if="!isSignin">
                          နောက်တစ်ဆင့်
                        </div>

                        <Loading
                          color="#000000"
                          v-if="isSignin"
                          size="24"
                          class="px-4 py-0"
                        />
                      </button>
                    </div>
                    <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
                  </form>
              </div>
            </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import { Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      phone: null,
      error: false,
      errors: {},
      isSignin: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    /**
     * login with phone
     */
     async OTPsendToPhone() {
      this.isSignin = true;
      this.error = null;
      
      if (!this.phone) {
        this.error =
          this.$store.state.language === 'en'
            ? 'Required Phone Number'
            : 'Phone Number လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }

      const phonePattern = /^(09\d{7,14}|\+959\d{7,14})$/;
      if (!phonePattern.test(this.phone)) {
        console.log('FAIL')
        this.error =
          this.$store.state.language === 'en'
            ? 'Invalid Phone Number'
            : 'ဖုန်းနံပါတ် မမှန်ကန်ပါ။';
        this.isSignin = false;
        return false;
      }

     
      try {
        const userData = {
          phone: this.phone,
        }

        const res = await this.axios.post(
            '/auth/sms-otp-sending',
            {...userData},
          );
        if(res.data.status === 'success') {
          this.$router.push('/auth/verify');
        }

          localStorage.setItem('pendingPhone', this.phone);

      } catch (error) {
        this.isSignin = false;
        console.log(error.response.data)
        if (error.response && error.response.data) {
          this.error = error.response.data.error;
        } else {
          this.error = this.$store.state.language === 'en'
              ? 'Registration Failed!'
              : 'အကောင့်ဖွင့်ခြင်း ကျရှုံးပါသည်။';
        }
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    if(this.$route.query.code){
      localStorage.setItem('referralCode', this.$route.query.code);
    }
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
  },
};
</script>

<style scoped>
.login-cont {
  padding-top: 3rem;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: white;
  border-radius: .5rem;
  padding: 0px 15px;
  background: #000000 !important; 
  border: 1px solid white !important;
  box-shadow: none !important;
  /* font-weight: bold; */
}

.auth-card {
  background: #eeecec;
  /* color: black */
}
</style>
